// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/v0.1.1481/css/" + chunkId + "." + {"181":"aa86d607","663":"08265ec8","978":"08265ec8"}[chunkId] + ".chunk.css";
};